export type StripeMode = 'test' | 'live';

export interface StripePublishableKeyConfig {
  key: string | null;
  mode: StripeMode | null;
  error: string | null;
}

const PUBLISHABLE_KEY_PATTERN = /^pk_(?:test|live)_[A-Za-z0-9]+$/u;

const normalizeMode = (value?: string): StripeMode | null => {
  const normalized = value?.trim().toLowerCase();
  if (!normalized) {
    return null;
  }
  if (normalized === 'test' || normalized === 'live') {
    return normalized;
  }
  throw new Error('Stripe の実行モード設定が不正です。管理者にお問い合わせください。');
};

export const resolveStripePublishableKey = (
  publishableKey?: string,
  configuredMode?: string,
): StripePublishableKeyConfig => {
  let mode: StripeMode | null;
  try {
    mode = normalizeMode(configuredMode);
  } catch (error) {
    return {
      key: null,
      mode: null,
      error: error instanceof Error ? error.message : 'Stripe の実行モード設定が不正です。',
    };
  }

  const key = publishableKey?.trim() ?? '';
  if (!key) {
    return {
      key: null,
      mode,
      error:
        'Stripe の公開鍵が設定されていないため、決済フォームを表示できません。管理者にお問い合わせください。',
    };
  }

  if (!PUBLISHABLE_KEY_PATTERN.test(key)) {
    return {
      key: null,
      mode,
      error: 'Stripe の公開鍵形式が不正です。管理者にお問い合わせください。',
    };
  }

  if (mode === 'test' && !key.startsWith('pk_test_')) {
    return {
      key: null,
      mode,
      error:
        'テスト環境に本番用のStripe公開鍵は使用できません。決済フォームを停止しました。',
    };
  }

  if (mode === 'live' && !key.startsWith('pk_live_')) {
    return {
      key: null,
      mode,
      error:
        '本番環境にテスト用のStripe公開鍵は使用できません。決済フォームを停止しました。',
    };
  }

  return { key, mode, error: null };
};
